export enum FilterType {
  WITH_SETUP_FEE = 'with_setup_fee',
  WITH_GRACE_PERIOD = 'with_grace_period',
  WITH_MERCHANT_DISCOUNT_PERCENTAGE = 'with_merchant_discount_percentage',
}

export interface Filter {
  type: FilterType;
  isActive: boolean;
}
